"use client";

// # START_CONTRACT
// FILE: src/features/demo/constants.ts
// PURPOSE: Константы демо-доступа в CRM (тестовый тенант без регистрации).
// SCOPE: используется кнопкой «Посмотреть демо CRM» на /login и плашкой
//        демо-тенанта в DashboardShell.
// END_CONTRACT

// <MEMENTO>Это ПУБЛИЧНЫЙ демо-аккаунт: credentials намеренно захардкожены и
// видны каждому посетителю oxpa.pro. Данные изолированы RLS демо-тенанта
// (00000000-0000-0000-0000-00000000d350, миграция
// 20260909000001_demo_tenant_seed.sql). Это НЕ утечка и НЕ костыль — не
// «чинить» и не выносить в env. UUID тенанта менять только вместе с
// миграцией.</MEMENTO>
export const DEMO_TENANT_ID = "00000000-0000-0000-0000-00000000d350";

export const DEMO_CREDENTIALS = {
  email: "demo@oxpa.pro",
  password: "Demo2026!Oxpa",
} as const;
// # END_FILE
